import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import { StyledButton } from '@app/components/button/Button';
import { StyledCard } from '@app/components/card/Card';

export type UserListFilterWidgetProps = {
	onSubmit: () => void;
	onReset: () => void;
};

export const UserListFilterWidget = ({ onSubmit, onReset }: UserListFilterWidgetProps) => {
	return (
		<StyledCard size="small">
			<p className="h4">Filters</p>

			<p>Insert form inputs here...</p>

			<StyledButtonGroup justify="space-between">
				<StyledButton type="default" color="red" onClick={onReset}>
					Reset
				</StyledButton>
				<StyledButton type="primary" color="green" onClick={onSubmit}>
					Apply
				</StyledButton>
			</StyledButtonGroup>
		</StyledCard>
	);
};
